export default __webpack_public_path__ + "static/project-start1-0cc34b8a49d244f4b4ff2393ff953ea5.png";